var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toolbarBtn",class:{active: _vm.active},attrs:{"type":"button"},on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/img/CITEditor/italic.svg"),"alt":"italic","title":"italic"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }